const user = (state = null, action) => {
  const { payload, type } = action;

  let isSub;
  let found;
  let blocked;
  switch (type) {
    case 'INITIAL_DATA':
      if (!payload.user) return {};

      return {
        ...payload.user,
        posts: payload.user.posts
      };

    case 'SET_USER':
      return payload;

    case 'UPDATE_USER':
      return {
        ...state,
        ...payload,
        posts: state.posts,
        shoutouts: state.shoutouts,
        sentShoutouts: state.sentShoutouts
      };

    case 'UPDATE_USER_POSTS':
      return {
        ...state,
        posts: payload
      };

    case 'BLOCK':
      blocked = state.blocked || [];
      found = blocked.find((x) => x === payload);

      return {
        ...state,
        blocked: found ? blocked.filter((x) => x !== payload) : [payload, ...blocked],
        following: state.following.filter((x) => x !== payload)
      };

    case 'FOLLOW':
      return {
        ...state,
        following: [payload, ...(state?.following || [])],
        followingCount: state?.followingCount + 1
      };

    case 'FOLLOW_MULTI':
      return {
        ...state,
        following: [...payload, ...(state.following || [])],
        followingCount: state.followingCount + payload.length
      };

    case 'UNFOLLOW':
      return {
        ...state,
        following: state.following.filter((x) => x !== payload),
        followingCount: state.followingCount - 1
      };

    case 'SUBSCRIBE':
      return {
        ...state,
        subscribed: [...payload.subscribedIds, ...(state.subscribed || [])],
        subscribedCount: state.subscribedCount + payload.subscribedIds.length,
        following: [...payload.subscribedIds, ...(state.following || [])],
        followingCount: state.followingCount + payload.subscribedIds.length
      };

    case 'UNSUBSCRIBE':
      return {
        ...state,
        subscribed: state.subscribed.filter((x) => !payload.unsubedIds.includes(x)),
        subscribedCount: state.subscribedCount - payload.unsubedIds.length,
        following: state.following.filter((x) => !payload.unsubedIds.includes(x)),
        followingCount: state.followingCount - payload.unsubedIds.length
      };

    case 'ADD_REACTION_TO_POST':
      const { prevReaction, entityId, reaction } = payload;

      const exists = state.reactions.find((r) => r.entityId === entityId);

      if (exists && exists.reaction === reaction) {
        return {
          ...state,
          reactions: state.reactions.filter((r) => r.entityId !== entityId)
        };
      }

      if (exists) {
        return {
          ...state,
          reactions: state.reactions.map((r) => {
            if (r.entityId !== entityId) return r;

            return {
              entityId: payload.entityId,
              reaction: payload.reaction
            };
          })
        };
      }

      return {
        ...state,
        reactions: [
          {
            entityId: payload.entityId,
            reaction: payload.reaction
          },
          ...state.reactions
        ]
      };

    case 'ADD_REACTION_TO_SHOUTOUT': {
      const { prevReaction, entityId, reaction } = payload;

      const exists = state.reactions.find((r) => r.entityId === entityId);

      if (exists && exists.reaction === reaction) {
        return {
          ...state,
          reactions: state.reactions.filter((r) => r.entityId !== entityId),
          shoutouts: state.shoutouts.map((shoutout) => {
            if (shoutout._id !== entityId) return shoutout;

            return {
              ...shoutout,
              reactionCounts: {
                ...shoutout.reactionCounts,
                [prevReaction]: shoutout.reactionCounts[prevReaction] - 1
              }
            };
          }),
          sentShoutouts: state.sentShoutouts.map((shoutout) => {
            if (shoutout._id !== entityId) return shoutout;

            return {
              ...shoutout,
              reactionCounts: {
                ...shoutout.reactionCounts,
                [prevReaction]: shoutout.reactionCounts[prevReaction] - 1
              }
            };
          })
        };
      }

      if (exists) {
        return {
          ...state,
          reactions: state.reactions.map((r) => {
            if (r.entityId !== entityId) return r;

            return {
              entityId: payload.entityId,
              reaction: payload.reaction
            };
          }),
          shoutouts: state.shoutouts.map((shoutout) => {
            if (shoutout._id !== entityId) return shoutout;

            return {
              ...shoutout,
              reactionCounts: {
                ...shoutout.reactionCounts,
                [prevReaction]: (shoutout.reactionCounts?.[prevReaction] ?? 0) - 1,
                [reaction]: (shoutout.reactionCounts?.[reaction] ?? 0) + 1
              }
            };
          }),
          sentShoutouts: state.sentShoutouts.map((shoutout) => {
            if (shoutout._id !== entityId) return shoutout;

            return {
              ...shoutout,
              reactionCounts: {
                ...shoutout.reactionCounts,
                [prevReaction]: (shoutout.reactionCounts?.[prevReaction] ?? 0) - 1,
                [reaction]: (shoutout.reactionCounts?.[reaction] ?? 0) + 1
              }
            };
          })
        };
      }

      return {
        ...state,
        reactions: [
          {
            entityId,
            reaction
          },
          ...state.reactions
        ],
        shoutouts: state.shoutouts.map((shoutout) => {
          if (shoutout._id !== entityId) return shoutout;

          return {
            ...shoutout,
            reactionCounts: {
              ...shoutout.reactionCounts,
              [reaction]: (shoutout.reactionCounts?.[reaction] ?? 0) + 1
            }
          };
        }),
        sentShoutouts: state.sentShoutouts.map((shoutout) => {
          if (shoutout._id !== entityId) return shoutout;

          return {
            ...shoutout,
            reactionCounts: {
              ...shoutout.reactionCounts,
              [reaction]: (shoutout.reactionCounts?.[reaction] ?? 0) + 1
            }
          };
        })
      };
    }

    case 'SET_SCHEDULE':
      return {
        ...state,
        schedule: payload
      };

    case 'ADD_POST':
      return {
        ...state,
        posts: [payload, ...state.posts]
      };

    case 'REMOVE_POST':
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== payload)
      };

    case 'REMOVE_SUGGESTION':
      return {
        ...state,
        removedSuggestions: [payload, ...state.removedSuggestions]
      };

    /*
      New notifications can also send relative data to that event,
      We check here and put the necessary data inside the user object
    */
    case 'NEW_NOTIFICATION':
      let rest = {};

      if (payload.shoutout) {
        rest = {
          shoutouts: [payload.shoutout, ...state.shoutouts],
          shoutoutCount: state.shoutCount + 1
        };
      }

      return {
        ...state,
        ...rest,
        notifCount: (state.notifCount || 0) + 1
      };

    case 'UPDATE_CONNECT_STATUS':
      if (!payload.notifStatus) return state;

      return {
        ...state,
        notifCount: (state.notifCount || 0) + 1
      };

    case 'SENT_SHOUTOUT':
      return {
        ...state,
        sentShoutoutCount: state.sentShoutoutCount + 1,
        sentShoutouts: [payload, ...state.sentShoutouts]
      };

    case 'MARK_ALL_NOTIFS_READ':
      return {
        ...state,
        notifCount: 0
      };

    case 'UPDATE_NOTIF_COUNT':
      return {
        ...state,
        notifCount: payload
      };

    case 'ADD_SEARCH_ITEM':
      let filteredSearches = (state.recentSearches || []).filter(
        (x) => x.target?._id !== payload.target._id
      );
      if (filteredSearches.length >= 4) filteredSearches.pop();
      filteredSearches.unshift(payload);

      return {
        ...state,
        recentSearches: filteredSearches
      };

    case 'REMOVE_SEARCH_ITEM':
      return {
        ...state,
        recentSearches: state.recentSearches.filter(
          (x) => (x.target?._id || x.target) !== (payload._id || payload)
        )
      };

    case 'SET_PAYMENT_HISTORY':
      return {
        ...state,
        paymentHistory: payload
      };

    case 'UPDATE_BILLING':
      return {
        ...state,
        billing: {
          ...state.billing,
          ...payload
        }
      };

    case 'UPDATE_ID_VERIFICATION_PROGRESS':
      return {
        ...state,
        verified: {
          ...(state.verified || {}),
          idProgress: payload
        }
      };

    case 'EMAIL_VERIFIED':
      return {
        ...state,
        verified: {
          ...(state.verified || {}),
          email: true
        }
      };

    case 'UPDATE_PRIVACY_SETTINGS':
      return {
        ...state,
        privacySettings: {
          ...(state.privacySettings || {}),
          ...payload
        }
      };

    case 'ADD_STORY':
      return {
        ...state,
        lastStoryAt: new Date()
      };

    case 'ADD_SENT_SHOUTOUT':
      return {
        ...state,
        sentShoutouts: [...state.sentShoutouts.filter((x) => x._id !== payload._id), payload]
      };

    case 'FAVORITE_PRODUCT': {
      const exists = state.favoriteProducts.find((r) => r === payload);

      if (exists) {
        return {
          ...state,
          favoriteProducts: state.favoriteProducts.filter((x) => x !== payload)
        };
      }

      return {
        ...state,
        favoriteProducts: [payload, ...state.favoriteProducts]
      };
    }

    case 'UPDATE_CART': {
      const { product, qty, stockId } = payload;
      let cart = state.cart || [];

      /*
        Find existent
      */
      const exists = cart.find((x) => product._id === x?.product?._id && stockId === x.stockId);

      /*
        If existent, do update operation.
        if qty is < 0, remove from cart
      */
      if (exists && qty <= 0) {
        cart = cart.filter((x) => x !== exists);

        return { ...state, cart };
      }

      /*
        If not existent and qty < 0
        (It can happen when 0 is inputted into the quantity twice)
        don't update the cart
      */
      if (qty <= 0) return state;

      /*
        Exists, add updated qty value
      */
      if (exists) {
        return {
          ...state,
          cart: cart.map((x) => {
            if (x !== exists) return x;

            return { ...x, qty };
          })
        };
      }

      return {
        ...state,
        cart: [...cart, payload]
      };
    }

    case 'UPDATE_PROFILE_VIEW_COUNT':
      return {
        ...state,
        profileViews: payload.user.profileViews,
        profileViewsCount: payload.user.profileViewsCount
      };

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default user;
